import client from './axiosInstance';
import { IHolidayInfoUpdatingData } from 'features/holidayInfo/holidayInfoTypes';

export const fetchHolidayInfo = async (holidayId: number) => {
  return await client.get(`/time-off/holidays/${holidayId}`);
};

export const updateHolidayInfo = async (data: IHolidayInfoUpdatingData) => {
  return await client.patch(`/time-off/holidays/${data.id}`, {
    ...data,
  });
};
